/**
 * PLA-8815: copy Figma has NOT authored yet, verbatim from the file.
 *
 * Most `Why this result?` bodies are still Lorem Ipsum in the mockup
 * (design/figma-live-read-2026-08-11.md § "The `Reason:` line — EXISTS, and is still placeholder").
 * An earlier build wrote plausible domain prose into the Data Trust & Integration Health card's slot
 * instead, which reads as authored, signed-off copy that nothing at review distinguishes from the
 * real thing.
 *
 * Placeholders rather than empty strings on purpose: the box still demonstrates, and "copy not
 * written yet" stays distinguishable from the empty, loading and error states.
 *
 * Do not replace either with invented prose — see the design note's own "Do not invent replacements".
 */

/**
 * The `Why this result?` and `Model evidence` bodies, which take Lorem at its full length
 * (`design/figma-spec.md:366`, listed beside `Model evidence` and `Why this result?`).
 */
export const PLACEHOLDER_WHY_THIS_RESULT =
  'Lorem Ipsum is dummy text commonly used in graphic design, publishing, and web development to fill spaces where content will eventually appear, allowing designers to focus on layout and visual presentation rather than meaningful text';

/**
 * The `Reason:` line beside a confidence chip, which takes a SHORTER Lorem — it stops at
 * `publishing`. Two independent reads agree: the live canvas on `Ready for Engagement`
 * (`589:32774`), where the chip says `High confidence · 82%`, and a CDP read of the Customer
 * Lifecycle & Holdings card (`design/card-customer-lifecycle-holdings-devmode-2026-08-12.md:45`).
 *
 * The file draws a THIRD length — through `eventually appear` — on the `Successfully sent to Growth
 * Planner` modal (`figma-spec.md:148`, `:189`). That surface has no constant here yet.
 *
 * Kept separate from the body constant rather than shared: one constant across both surfaces means
 * every fix to one silently rewrites the other, which is how the body copy got truncated once.
 */
export const PLACEHOLDER_CONFIDENCE_REASON =
  'Lorem Ipsum is dummy text commonly used in graphic design, publishing';
